import React from "react";
import StatementsContainer from "../containers/StatementsContainer/StatementsContainer";
import BulkBillsContainer from "../containers/BulkBillsContainer/BulkBillsContainer";
import BillsPrepaymentsContainer from "../containers/BillsPrepaymentsContainer/BillsPrepaymentsContainer";
import PaymentsContainer from "../containers/PaymentsContainer/PaymentsContainer";
import ChargesContainer from "../containers/ChargesContainer/ChargesContainer";
import ChargesDetailsContainer from "../containers/ChargesDetailsContainer/ChargesDetailsContainer";
import BulkServicesContainer from "../containers/BulkServicesContainer/BulkServicesContainer";
import TasksContainer from "../containers/TasksContainer/TasksContainer";
import RejectedTrafficContainer from "../containers/RejectedTrafficContainer/RejectedTrafficContainer";
import RejectedTrafficDetailContainer from "../containers/RejectedTrafficDetalContainer/RejectedTrafficDetailContainer";
import { DictionariesContainer } from "../containers/DictionariesContainer/DictionariesContainer";
import AccountInfoContainer from "../containers/AccountInfoContainer/AccountInfoContainer";
import AccountAgreements from "../components/AccountAgreements/AccountAgreements";
import AccountBillsContainer from "../containers/AccountBillsContainer/AccountBillsContainer";
import AccountPaymentsContainer from "../containers/AccountPaymentsContainer/AccountPaymentsContainer";
import AccountChargesContainer from "../containers/AccountChargesContainer/AccountChargesContainer";
import AccountDetalizationContainer from "../containers/AccountDetalizationContainer/AccountDetalizationContainer";
import AgreementDetails from "../components/AgreementDetails/AgreementDetails";
import AccountContainer from "../containers/AccountContainer/AccountContainer";
import AccountAgreementsContainer from "../containers/AccountAgreementsContainer/AccountAgreementsContainer";
import CurrenciesContainer from "../containers/CurrenciesContainer/CurrenciesContainer";
import { RoutingOrdersContainer } from "../containers/RoutingOrdersContainer/RoutingOrdersContainer";
import { RoutingPlansContainer } from "../containers/RoutingPlansContainer/RoutingPlansContainer";
import ServiceProfileContainer from "../containers/ServiceProfileContainer/ServiceProfileContainer";
import ServiceTypeCreateFormContainer from "../containers/ServiceTypeCreateFormContainer/ServiceTypeCreateFormContainer";
import ServiceTypesContainer from "../containers/ServiceTypesContainer/ServiceTypesContainer";
import ServiceProfileCreateFormContainer from "../containers/ServiceProfileCreateFormContainer/ServiceProfileCreateFormContainer";
import AccountAccumulatorsContainer from "../containers/AccountAccumulatorsContainer/AccountAccumulatorsContainer";
import RolesModule from "../components/RolesModule/RolesModule";
import {
  MENU_ACCOUNT_ACCOUNTINFO,
  MENU_ACCOUNT_AGREEMENT,
  MENU_ACCOUNT_BILLS,
  MENU_ACCOUNT_CHARGES,
  MENU_ACCOUNT_PAYMENTS,
  MENU_ACCOUNT_SERVICES,
  MENU_ACCOUNT_TRANSACTION,
  MENU_ACCOUNTS,
  MENU_ACCOUNTS_WRITE,
  MENU_ACCOUNTS_ORGANIZATION,
  MENU_ACCOUNTS_ORGANIZATION_WRITE,
  MENU_ACCOUNTS_INDIVIDUAL,
  MENU_ACCOUNTS_INDIVIDUAL_WRITE,
  MENU_ADMIN_EXCHANGE,
  MENU_ADMIN_SERVICEBILLINGPROFILE,
  MENU_ADMIN_SERVICETYPE,
  MENU_BILLING_ACCOUNTINGSYSTEM,
  MENU_BILLING_PREPAYMENTBILL,
  MENU_BILLING_TRAFFIC,
  MENU_BILLS,
  MENU_CHARGES,
  MENU_PAYMENTLOAD,
  MENU_PAYMENTS,
  MENU_SERVICES,
  MENU_TASKMANAGER,
  MENU_USER_USERMANAGEMENT,
  MENU_ACCOUNT_ACCOUNTINFO_WRITE,
  MENU_ACCOUNT_AGREEMENT_WRITE,
  MENU_ACCOUNT_SERVICES_WRITE,
  MENU_ACCOUNT_BILLS_WRITE,
  MENU_ACCOUNT_PAYMENTS_WRITE,
  MENU_ACCOUNT_CHARGES_WRITE,
  MENU_ACCOUNT_TRANSACTION_WRITE,
  MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE,
  MENU_PAYMENTLOAD_WRITE,
  MENU_BILLS_WRITE,
  MENU_BILLING_PREPAYMENTBILL_WRITE,
  MENU_PAYMENTS_WRITE,
  MENU_CHARGES_WRITE,
  MENU_SERVICES_WRITE,
  MENU_TASKMANAGER_WRITE,
  MENU_BILLING_TRAFFIC_WRITE,
  MENU_BILLING_ACCOUNTINGSYSTEM_WRITE,
  MENU_USER_USERMANAGEMENT_WRITE,
  MENU_ADMIN_EXCHANGE_WRITE,
  MENU_ADMIN_SERVICETYPE_WRITE,
  MENU_ADMIN_DIC,
  MENU_ADMIN_DIC_WRITE,
  MENU_ADMIN_TENANT,
  MENU_ADMIN_TENANT_WRITE,
  MENU_ADMIN_PROPERTY_TYPE,
  MENU_ADMIN_PROPERTY_TYPE_WRITE,
  MENU_BILLING_BILLINGPROCEDURES_WRITE,
  MENU_BILLING_BILLINGPROCEDURES,
  MENU_BILLING_ROLLBACK,
  MENU_BILLING_ROLLBACK_WRITE,
  MENU_ADMIN_INFOTEMPLATE_WRITE,
  MENU_ADMIN_INFOTEMPLATE,
  MENU_ACCOUNT_AGG_USAGE,
  MENU_ACCOUNT_AGG_USAGE_WRITE,
  MENU_ADMIN_OFFERING,
  MENU_ADMIN_OFFERING_WRITE,
  MENU_TC_ACCOUNT_AGREEMENT_TARIFF_WRITE,
  MENU_TC_ADMIN_DESTINATIONS_WRITE,
  MENU_TC_ADMIN_DESTINATIONS,
  MENU_TC_ROUTING_ORDERS_WRITE,
  MENU_TC_ROUTING_ORDERS,
  MENU_TC_ROUTING_ROUTING_PLAN_WRITE,
  MENU_TC_ROUTING_ROUTING_PLAN,
  MENU_ADMIN_BLOCKING_TYPE_WRITE,
  MENU_ADMIN_BLOCKING_TYPE,
  MENU_ADMIN_OFFERING_POLICY,
  MENU_ADMIN_OFFERING_POLICY_WRITE,
  MENU_ADMIN_OFFERING_GROUP,
  MENU_ADMIN_OFFERING_GROUP_WRITE,
  MENU_ADMIN_CHAR_TYPE,
  MENU_ADMIN_CHAR_TYPE_WRITE,
  MENU_ADMIN_OBJECT_CHAR_TYPE,
  MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE,
  MENU_ADMIN_REPORT_TEMPLATE_READ,
  MENU_ADMIN_REPORT_TEMPLATE,
  MENU_REPORTS,
  MENU_REPORTS_WRITE,
  BILLING_ACCOUNTING_SYSTEM_PROCEDURES,
  BILLING_ACCOUNTING_SYSTEM_EXTNUM,
  BILLING_ACCOUNTING_SYSTEM_TASKS,
  BILLING_ACCOUNTING_SYSTEM_EXPORT,
} from "../lib/const/permissions";
import ClosedDocumentsContainer from "../containers/ClosedDocumentsContainer/ClosedDocumentsContainer";
import CountingDepartmentContainer from "../containers/CountingDepartmentContainer/CountingDepartmentContainer";
import PropertyTypesAdminContainer from "../containers/ProprtyTypesAdminContainer/PropertyTypesAdminContainer";
import TenantsAdminContainer from "../containers/TenantsContainer/TenantsContainer";
import AccountsContainer from "../containers/AccountsContainer/AccountsContainer";
import AccountAgreementsCreate from "../components/AccountAgreementsCreate/AccountAgreementsCreate";
import AccountCreateContainer from "../containers/AccountCreateContainer/AccountCreateContainer";
import AccountIndividualCreateContainer from "../containers/AccountIndividualCreateContainer/AccountIndividualCreateContainer";
import BillingRollbackContainer from "../containers/BillingRollbackContainer/BillingRollbackContainer";
import AccountsListContainerTs from "../containers/AccountListContainerTs/AccountsListContainerTs";
import AccountsIndividualContainerTs from "../containers/AccountsIndividualContainerTs/AccountsIndividualContainerTs";
import { TemplatesContainer } from "../containers/TemplatesContainer/TemplatesContainer";
import { UploadPriceContainer } from "../containers/UploadPriceContainer/UploadPriceContainer";
import { hasAccess } from "../components/RolesModule/hasAccess";
import featuresToggle from "../lib/utils/featuresToggle";
import { hasLocalAccess } from "../lib/configs";
import { AccountContacts } from "../components/AccountContacts/AccountContacts";
import AccountInfo from "../components/AccountInfo/AccountInfo";
import { AccountContactsDetails } from "../components/AccountContacts/AccountContactsDetails/AccountContactsDetails";
import { OfferContainer } from "../containers/OfferContainer/OfferContainer";
import { DestinationListContainer } from "../containers/DestinationListContainer/DestinationListContainer";
import { DestinationDetailsContainer } from "../containers/DestinationDetailsContainer/DestinationDetailsContainer";
import { AccountProductsContainer } from "../containers/AccountProductsContainer/AccountProductsContainer";
import BlockingTypesContainer from "../containers/BlockingTypesContainer/BlockingTypesContainer";
import BlockingTypesAdminCreateContainer from "../containers/BlockingTypesAdminCreateContainer/BlockingTypesAdminCreateContainer";
import { AccessForbidden } from "../components/common";
import { getMainRedirectPath } from "./getMainRedirectPath";
import { PoliciesContainer, OfferingGroupsContainer } from "../modules/policies";
import { TypesCharacteristicsContainer } from "../modules/TypesCharacteristics";
import { TypesCharacteristicsObjectContainer } from "../modules/TypesCharacteristicsObject";
import DocumentTemplatesContainer from "../containers/DocumentTemplatesContainer/DocumentTemplatesContainer";
import { WelcomeContainer } from "../containers/WelcomeContainer/WelcomeContainer";
import ReportsContainer from "../containers/ReportsContainer/ReportsContainer";
import { AccountPaymentDetailsPage } from "../modules/AccountPaymentDetails";
import LoginPage from "../components/LoginPage/LoginPage";

export interface IRoute {
  path: string;
  exact: boolean;
  // Компонент для рендера
  component?: React.ReactNode;
  // Nested роуты
  routes?: IRoute[];
  // Redirect path
  redirect?: string;
  // Доступ только для авторизацованных пользователей
  private?: boolean;
  // Есть ли у пользователя привилегии для данного компонента
  permissions?: string | string[];
  // Есть ли у пользователя привилегии для его подкомпонентов
  permissionsDeep?: string | string[];
}

export interface IGenerateRoutesProps {
  // Для блокировки маршрутов в зависимости от режима блокировки
  isBlockingMode: boolean;
}

const isAccountsIndividualAvailable = featuresToggle({
  value: true,
  alternativeValue: false,
  condition: hasLocalAccess("feature.accounts/individual"),
});

const mainRedirectPath = getMainRedirectPath({
  isHasAccessOrganization: hasAccess(
    MENU_ACCOUNTS,
    MENU_ACCOUNTS_WRITE,
    MENU_ACCOUNTS_ORGANIZATION,
    MENU_ACCOUNTS_ORGANIZATION_WRITE
  ),
  isHasAccessIndividual: hasAccess(MENU_ACCOUNTS_INDIVIDUAL, MENU_ACCOUNTS_INDIVIDUAL_WRITE),
  isHasAccessOffering: hasAccess(MENU_ADMIN_OFFERING, MENU_ADMIN_OFFERING_WRITE),
});

const isCreateAccountAvailable = featuresToggle({
  value: true,
  alternativeValue: false,
  condition: hasLocalAccess("feature.createAccount"),
});

const AccessForbiden = () => <h2 style={{ marginTop: "15px" }}>Доступ к разделу отсуствует</h2>;

const checkAccess = (component: React.ReactNode, hasAccess: boolean): React.ReactNode =>
  hasAccess ? component : AccessForbiden;

export const generateRoutes = ({ isBlockingMode }: IGenerateRoutesProps): IRoute[] => {
  const routes: IRoute[] = [
    {
      path: "/",
      redirect: mainRedirectPath,
      exact: true,
      private: true,
    },
    {
      path: "/login",
      component: LoginPage,
      exact: false,
      private: false,
    },
    {
      path: "/accounts",
      component: AccountsContainer,
      exact: false,
      private: true,
      permissions: [
        MENU_ACCOUNTS,
        MENU_ACCOUNTS_WRITE,
        MENU_ACCOUNTS_ORGANIZATION,
        MENU_ACCOUNTS_ORGANIZATION_WRITE,
        MENU_ACCOUNTS_INDIVIDUAL,
        MENU_ACCOUNTS_INDIVIDUAL_WRITE,
      ],
      routes: [
        {
          path: "/accounts/list",
          component: AccountsListContainerTs,
          exact: true,
          private: true,
          permissions: [
            MENU_ACCOUNTS_ORGANIZATION,
            MENU_ACCOUNTS_ORGANIZATION_WRITE,
            MENU_ACCOUNTS,
            MENU_ACCOUNTS_WRITE,
          ],
        },
        {
          path: "/accounts/individual",
          component: checkAccess(AccountsIndividualContainerTs, isAccountsIndividualAvailable),
          exact: true,
          private: true,
          permissions: [MENU_ACCOUNTS_INDIVIDUAL, MENU_ACCOUNTS_INDIVIDUAL_WRITE],
        },
        {
          path: "/accounts/create",
          component: checkAccess(AccountCreateContainer, isCreateAccountAvailable),
          exact: true,
          private: true,
        },
        {
          path: "/accounts/create-individual",
          component: checkAccess(
            AccountIndividualCreateContainer,
            isAccountsIndividualAvailable && isCreateAccountAvailable
          ),
          exact: true,
          private: true,
        },
        {
          path: "/accounts/:accountId",
          exact: false,
          component: AccountContainer,
          private: true,
          routes: [
            {
              path: "/accounts/:accountId/info",
              component: checkAccess(AccountInfoContainer, hasLocalAccess("account.info")),
              exact: false,
              private: true,
              permissions: [MENU_ACCOUNT_ACCOUNTINFO, MENU_ACCOUNT_ACCOUNTINFO_WRITE],
              routes: [
                {
                  path: "/accounts/:accountId/info/contacts",
                  component: checkAccess(AccountContacts, hasLocalAccess("account.contactList")),
                  exact: false,
                  private: true,
                  // permissions: [MENU_ACCOUNT_ACCOUNTINFO, MENU_ACCOUNT_ACCOUNTINFO_WRITE],
                },
                {
                  path: "/accounts/:accountId/info",
                  component: AccountInfo,
                  exact: true,
                  private: true,
                  permissions: [MENU_ACCOUNT_ACCOUNTINFO, MENU_ACCOUNT_ACCOUNTINFO_WRITE],
                },
                {
                  path: "/accounts/:accountId/info/:searchParams",
                  component: checkAccess(
                    AccountContactsDetails,
                    hasLocalAccess("account.contactListDetails")
                  ),
                  exact: false,
                  private: true,
                  // permissions: [MENU_ACCOUNT_ACCOUNTINFO, MENU_ACCOUNT_ACCOUNTINFO_WRITE],
                },
              ],
            },
            {
              path: "/accounts/:accountId/agreements",
              component: checkAccess(
                AccountAgreementsContainer,
                hasLocalAccess("account.agreements")
              ),
              exact: false,
              private: true,
              permissions: [MENU_ACCOUNT_AGREEMENT, MENU_ACCOUNT_AGREEMENT_WRITE],
              routes: [
                {
                  path: "/accounts/:accountId/agreements/",
                  component: checkAccess(AccountAgreements, hasLocalAccess("account.agreements")),
                  exact: true,
                  private: true,
                  permissions: [MENU_ACCOUNT_AGREEMENT, MENU_ACCOUNT_AGREEMENT_WRITE],
                },
                {
                  path: "/accounts/:accountId/agreements/create",
                  component: AccountAgreementsCreate,
                  exact: false,
                  private: true,
                  permissions: [MENU_ACCOUNT_AGREEMENT, MENU_ACCOUNT_AGREEMENT_WRITE],
                },
                {
                  path: "/accounts/:accountId/agreements/:agreementId",
                  component: AgreementDetails,
                  exact: true,
                  private: true,
                  permissions: [MENU_ACCOUNT_AGREEMENT, MENU_ACCOUNT_AGREEMENT_WRITE],
                },
                {
                  path: "/accounts/:accountId/agreements/:agreementId/upload-price",
                  component: checkAccess(
                    UploadPriceContainer,
                    hasLocalAccess("feature.upload.price")
                  ),
                  exact: false,
                  private: true,
                  permissions: [MENU_TC_ACCOUNT_AGREEMENT_TARIFF_WRITE],
                },
              ],
            },
            {
              path: "/accounts/:accountId/products",
              component: checkAccess(AccountProductsContainer, hasLocalAccess("account.products")),
              exact: false,
              private: true,
              permissions: [MENU_ACCOUNT_SERVICES, MENU_ACCOUNT_SERVICES_WRITE],
            },
            {
              path: "/accounts/:accountId/bills",
              component: checkAccess(AccountBillsContainer, hasLocalAccess("account.bills")),
              exact: false,
              private: true,
              permissions: [MENU_ACCOUNT_BILLS, MENU_ACCOUNT_BILLS_WRITE],
            },
            {
              path: "/accounts/:accountId/payments",
              component: checkAccess(AccountPaymentsContainer, hasLocalAccess("account.payments")),
              exact: true,
              private: true,
              permissions: [MENU_ACCOUNT_PAYMENTS, MENU_ACCOUNT_PAYMENTS_WRITE],
            },
            {
              path: "/accounts/:accountId/payments/:paymentId",
              component: AccountPaymentDetailsPage,
              exact: true,
              private: true,
              permissions: [MENU_ACCOUNT_PAYMENTS, MENU_ACCOUNT_PAYMENTS_WRITE],
            },
            {
              path: "/accounts/:accountId/charges",
              component: checkAccess(AccountChargesContainer, hasLocalAccess("account.charges")),
              exact: false,
              private: true,
              permissions: [MENU_ACCOUNT_CHARGES, MENU_ACCOUNT_CHARGES_WRITE],
            },
            {
              path: "/accounts/:accountId/accumulators",
              component: checkAccess(
                AccountAccumulatorsContainer,
                hasLocalAccess("account.accumulators")
              ),
              exact: false,
              private: true,
              permissions: [MENU_ACCOUNT_AGG_USAGE, MENU_ACCOUNT_AGG_USAGE_WRITE],
            },
            {
              path: "/accounts/:accountId/detalization",
              component: checkAccess(
                AccountDetalizationContainer,
                hasLocalAccess("account.detalization")
              ),
              exact: false,
              private: true,
              permissions: [MENU_ACCOUNT_TRANSACTION, MENU_ACCOUNT_TRANSACTION_WRITE],
            },
          ],
        },
      ],
    },
    {
      path: "/statements",
      component: StatementsContainer,
      exact: false,
      private: true,
      permissions: [MENU_PAYMENTLOAD, MENU_PAYMENTLOAD_WRITE],
    },
    {
      path: "/bills",
      component: BulkBillsContainer,
      exact: false,
      private: true,
      permissions: [MENU_BILLS, MENU_BILLS_WRITE],
    },
    {
      path: "/bills-prepayments",
      component: BillsPrepaymentsContainer,
      exact: false,
      private: true,
      permissions: [MENU_BILLING_PREPAYMENTBILL, MENU_BILLING_PREPAYMENTBILL_WRITE],
    },
    {
      path: "/payments",
      component: PaymentsContainer,
      exact: false,
      private: true,
      permissions: [MENU_PAYMENTS, MENU_PAYMENTS_WRITE],
    },
    {
      path: "/charges",
      component: ChargesContainer,
      exact: false,
      private: true,
      permissions: [MENU_CHARGES, MENU_CHARGES_WRITE],
    },
    {
      path: "/charges-details/:chargeId",
      component: ChargesDetailsContainer,
      exact: false,
      private: true,
    },
    {
      path: "/services",
      component: BulkServicesContainer,
      exact: false,
      private: true,
      permissions: [MENU_SERVICES, MENU_SERVICES_WRITE],
    },
    {
      path: "/tasks",
      component: TasksContainer,
      exact: false,
      private: true,
      permissions: [MENU_TASKMANAGER, MENU_TASKMANAGER_WRITE],
    },
    {
      path: "/rejected-traffic",
      component: RejectedTrafficContainer,
      exact: false,
      private: true,
      permissions: [MENU_BILLING_TRAFFIC, MENU_BILLING_TRAFFIC_WRITE],
    },
    {
      path: "/counting-department",
      component: CountingDepartmentContainer,
      exact: false,
      private: true,
      permissions: [MENU_BILLING_ACCOUNTINGSYSTEM, MENU_BILLING_ACCOUNTINGSYSTEM_WRITE],
      permissionsDeep: [
        BILLING_ACCOUNTING_SYSTEM_EXPORT,
        BILLING_ACCOUNTING_SYSTEM_TASKS,
        BILLING_ACCOUNTING_SYSTEM_PROCEDURES,
        BILLING_ACCOUNTING_SYSTEM_EXTNUM,
      ],
    },
    {
      path: "/rejected-traffic-detail/:id",
      component: RejectedTrafficDetailContainer,
      exact: false,
      private: true,
    },
    {
      path: "/roles",
      component: RolesModule,
      exact: false,
      private: true,
      permissions: [MENU_USER_USERMANAGEMENT, MENU_USER_USERMANAGEMENT_WRITE],
    },
    {
      path: "/dictionaries",
      component: DictionariesContainer,
      exact: true,
      private: true,
      permissions: [MENU_ADMIN_DIC, MENU_ADMIN_DIC_WRITE],
    },
    {
      path: "/currencies",
      component: CurrenciesContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_EXCHANGE, MENU_ADMIN_EXCHANGE_WRITE],
    },
    {
      path: "/routing-orders",
      component: RoutingOrdersContainer,
      exact: false,
      private: true,
      permissions: [MENU_TC_ROUTING_ORDERS, MENU_TC_ROUTING_ORDERS_WRITE],
    },
    {
      path: "/routing-plans",
      component: RoutingPlansContainer,
      exact: false,
      private: true,
      permissions: [MENU_TC_ROUTING_ROUTING_PLAN, MENU_TC_ROUTING_ROUTING_PLAN_WRITE],
    },
    {
      path: "/service-profile",
      component: ServiceProfileContainer,
      exact: true,
      private: true,
      permissions: [MENU_ADMIN_SERVICEBILLINGPROFILE, MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE],
    },
    {
      path: "/service-profile/create",
      component: ServiceProfileCreateFormContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_SERVICEBILLINGPROFILE, MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE],
    },
    {
      path: "/service-types",
      component: ServiceTypesContainer,
      exact: true,
      private: true,
      permissions: [MENU_ADMIN_SERVICETYPE, MENU_ADMIN_SERVICETYPE_WRITE],
    },
    {
      path: "/service-types/create",
      component: ServiceTypeCreateFormContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_SERVICETYPE, MENU_ADMIN_SERVICETYPE_WRITE],
    },
    {
      path: "/closed-documents",
      component: ClosedDocumentsContainer,
      exact: false,
      private: true,
      permissions: [MENU_BILLING_BILLINGPROCEDURES, MENU_BILLING_BILLINGPROCEDURES_WRITE],
    },
    {
      path: "/billing-rollback",
      component: BillingRollbackContainer,
      exact: false,
      private: true,
      permissions: [MENU_BILLING_ROLLBACK, MENU_BILLING_ROLLBACK_WRITE],
    },
    {
      path: "/tenants",
      component: TenantsAdminContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_TENANT, MENU_ADMIN_TENANT_WRITE],
    },
    {
      path: "/property-types",
      component: PropertyTypesAdminContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_PROPERTY_TYPE, MENU_ADMIN_PROPERTY_TYPE_WRITE],
    },
    {
      path: "/templates",
      component: TemplatesContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_INFOTEMPLATE, MENU_ADMIN_INFOTEMPLATE_WRITE],
    },
    {
      path: "/reports",
      component: ReportsContainer,
      exact: false,
      private: true,
      permissions: [MENU_REPORTS, MENU_REPORTS_WRITE],
    },
    {
      path: "/offer",
      component: OfferContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_OFFERING, MENU_ADMIN_OFFERING_WRITE],
    },
    {
      path: "/destinations",
      component: DestinationListContainer,
      exact: false,
      private: true,
      permissions: [MENU_TC_ADMIN_DESTINATIONS, MENU_TC_ADMIN_DESTINATIONS_WRITE],
    },
    {
      path: "/destination/create",
      component: DestinationDetailsContainer,
      exact: false,
      private: true,
      permissions: [MENU_TC_ADMIN_DESTINATIONS_WRITE],
    },
    {
      path: "/destination/:destinationId",
      component: DestinationDetailsContainer,
      exact: false,
      private: true,
      permissions: [MENU_TC_ADMIN_DESTINATIONS, MENU_TC_ADMIN_DESTINATIONS_WRITE],
    },
    {
      path: "/blocking-types",
      component: isBlockingMode ? BlockingTypesContainer : AccessForbidden,
      exact: true,
      private: true,
      permissions: [MENU_ADMIN_BLOCKING_TYPE, MENU_ADMIN_BLOCKING_TYPE_WRITE],
    },
    {
      path: "/blocking-types/create",
      component: isBlockingMode ? BlockingTypesAdminCreateContainer : AccessForbidden,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_BLOCKING_TYPE, MENU_ADMIN_BLOCKING_TYPE_WRITE],
    },
    {
      path: "/policies",
      component: PoliciesContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_OFFERING_POLICY, MENU_ADMIN_OFFERING_POLICY_WRITE],
    },
    {
      path: "/offering-groups",
      component: OfferingGroupsContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_OFFERING_GROUP, MENU_ADMIN_OFFERING_GROUP_WRITE],
    },
    {
      path: "/types-characteristics",
      component: TypesCharacteristicsContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_CHAR_TYPE, MENU_ADMIN_CHAR_TYPE_WRITE],
    },
    {
      path: "/types-characteristics-object",
      component: TypesCharacteristicsObjectContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_OBJECT_CHAR_TYPE, MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE],
    },
    {
      path: "/document-templates",
      component: DocumentTemplatesContainer,
      exact: false,
      private: true,
      permissions: [MENU_ADMIN_REPORT_TEMPLATE_READ, MENU_ADMIN_REPORT_TEMPLATE],
    },
    {
      path: "/welcome",
      component: WelcomeContainer,
      exact: false,
      private: true,
    },
  ];
  return routes;
};
